import React from 'react';
import { Button } from 'react-bootstrap';
import styled from "styled-components";
import {ReactComponent as IconMenuBar} from '../assets/icons/iconmonstr-cat-7.svg';



const Li = styled.div `
    width: auto;
    margin: 10px;

`

const Span = styled.span`
color: #DF5931;

`


const Icono = styled(IconMenuBar)`
margin-left: 10px;
height: auto;
fill: #E6410F;
`


const Links = ({links}) => {

    return ( 
        <>
            {
                links && links.map((link) => {
                    return (

                       <Li className="d-grid gap-2" key={link.id_role_action}>
                        <Button href={link.url} variant='warning' ><Span><strong>{link.action_name}</strong></Span><Icono></Icono></Button>
                       </Li>                      
                    )
                })
            }
        </>

     );
}
 
export default Links;
